import React from 'react';

const PaymentError = () => {
  return (
    <div className="container text-center p-5">
      <h1>❌ Payment Error</h1>
      <p>There was an error processing your payment. Please try again or <a href="/contact">contact support</a></p>
    </div>
  );
};

export default PaymentError;
